import React from "react";

//mui
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

//components
import CustomPopper from "./PopperComponent";

const Container = styled("div")(({ theme }) => ({
  "& .MuiMenuItem-root": {
    // background: "green",
  },
  "& .MuiAutocomplete-root": {
    background: "#FFFFFF",
  },
  "& .MuiAutocomplete-input": {
    height: "19px",
    fontSize: "14px",
    [theme.breakpoints.down("xl")]: {
      height: "17px",
      fontSize: "14px",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "15px",
    color: "#4F4F4F",
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px",
    },
  },
}));

const AutoCompleteSelect = ({
  value,
  options,
  variant = "outlined",
  disabled = false,
  onChange,
  label,
  text,
  leftIcon,
  Outsidelabel = null,
  className = "",
  filterSelectedOptions = true,
  multiple = false,
  showSelectedTags = true,
  ...restProps
}) => {
  const Icon = leftIcon;

  const safeOptions = Array.isArray(options) ? options : [];
  const safeValue = multiple
    ? Array.isArray(value)
      ? value
      : []
    : value;

  return (
    <Container className={className}>
      {Outsidelabel}
      <FormControl variant="outlined" style={{ width: "100%", padding: 0 }}>
        <Autocomplete
          multiple={multiple}
          disableCloseOnSelect={multiple}
          fullWidth
          value={safeValue}
          options={safeOptions}
          isOptionEqualToValue={(option, value) =>
            option?.id === value?.id
          }
          getOptionLabel={(option) => (option ? option.name : "")}
          onChange={(event, newValue) => onChange(newValue, text)}
          filterSelectedOptions={filterSelectedOptions}
          renderOption={
            multiple
              ? (props, option, { selected }) => {
                  const { key, ...optionProps } = props;

                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        checked={selected}
                        sx={{ marginRight: 1 }}
                      />
                      {option.name}
                    </li>
                  );
                }
              : undefined
          }
          renderTags={
            multiple
              ? (selectedOptions, getTagProps) => {
                  if (!showSelectedTags || !selectedOptions.length) return null;

                  const firstLabel = selectedOptions[0].name;
                  const label =
                    selectedOptions.length > 1
                      ? `${firstLabel} + ${selectedOptions.length - 1}`
                      : firstLabel;

                  return <Chip label={label} {...getTagProps({ index: 0 })} />;
                }
              : undefined
          }
          renderInput={(params, index) => {
            const { InputProps, inputProps, ...renderProps } = params;
            // inputProps.disabled = disabled;
            // InputProps.endAdornment = disabled ? (
            //   <></>
            // ) : (
            //   InputProps.endAdornment
            // );
            return (
              <TextField
                key={index}
                {...renderProps}
                InputProps={{
                  ...InputProps,
                  // disableUnderline: variant === "standard" ? true : false,
                  startAdornment: leftIcon ? (
                    <>
                      <InputAdornment position="start">
                        <Icon />
                      </InputAdornment>
                      {InputProps.startAdornment}
                    </>
                  ) : (
                    InputProps.startAdornment
                  ),
                }}
                inputProps={inputProps}
                label={label}
                // placeholder="Text"
                // className={classes.input}
                variant={variant}
                {...restProps}
              />
            );
          }}
          PopperComponent={CustomPopper}
        />
      </FormControl>
    </Container>
  );
};

export default AutoCompleteSelect;
